import { gql } from '@apollo/client/core';

export const QUERY_GET_USER_BY_MAIL = gql`
  query getSwitchUserByMail($mail: String!) {
    getSwitchUserByMail(mail: $mail) {
      email
      phoneNumber
      id
      firstname
      lastname
      uniqId
      honorificPrefix
      lastTutorialCompletionDate
    }
  }
`;

export const GET_USER_BY_ID = gql`
  query getUserById($userId: String!, $isAdmin: Boolean) {
    getUserById(userId: $userId, isAdmin: $isAdmin) {
      phoneNumber
      email
      firstname
      lastname
      id
      countActiveOrganizations
      uniqId
      honorificPrefix
      lastTutorialCompletionDate
    }
  }
`;
